import { createContext, useContext } from 'react'
import type { LarryToHostMessage } from '@/lib/embed/host-messages'

/**
 * Set when Larry was opened inside a host app's iframe (`/embed`, Mary's spread ladder): the one
 * spread the host opened, and a way to message the host. Null in the standalone editor.
 */
export interface EmbedSession {
  /** The spread the host opened. The editor stays on it: spread navigation is locked. */
  spreadId: string
  /** Posts a message to the host window, at the host's origin only. */
  postToHost: (message: LarryToHostMessage) => void
}

const EmbedSessionContext = createContext<EmbedSession | null>(null)

export const EmbedSessionProvider = EmbedSessionContext.Provider

/** The embed session, or null when Larry isn't embedded. Unlike the editor contexts, never throws. */
export function useEmbedSession(): EmbedSession | null {
  return useContext(EmbedSessionContext)
}
